import { Config } from "./types";
import Img1 from "../images/sliderImages/img-1.webp";
import Img2 from "../images/sliderImages/img-2.webp";
import Img3 from "../images/sliderImages/img-3.webp";
import Img4 from "../images/sliderImages/img-4.webp";
import Img5 from "../images/sliderImages/img-5.webp";

const config: Config = {
    sliderImages: [
        {
            imgUrl: Img1,
            imgGradient:
                "radial-gradient(50% 50% at 50% 50%, rgba(36, 12, 107, 0.85) 0%, rgba(24, 6, 79, 0.9) 100%)",
            imgPosition: "20%",
            description: "Free Sign Up",
        },
        {
            imgUrl: Img2,
            imgGradient:
                "radial-gradient(50% 50% at 50% 50%, rgba(36, 12, 107, 0.85) 0%, rgba(24, 6, 79, 0.9) 100%)",
            imgPosition: "45%",
            description: "Talent Directory",
        },
        {
            imgUrl: Img3,
            imgGradient:
                "radial-gradient(50% 50% at 50% 50%, rgba(36, 12, 107, 0.85) 0%, rgba(24, 6, 79, 0.9) 100%)",
            imgPosition: "45%",
            description: "Explore Opportunities",
        },
        {
            imgUrl: Img4,
            imgGradient:
                "radial-gradient(50% 50% at 50% 50%, rgba(40, 13, 125, 0.94) 0%, rgba(40, 13, 125, 0.62) 100%)",
            imgPosition: "45%",
            description: "Add Castings",
        },
        {
            imgUrl: Img5,
            imgGradient:
                "radial-gradient(50% 50% at 50% 50%, rgba(36, 12, 107, 0.85) 0%, rgba(24, 6, 79, 0.9) 100%)",
            imgPosition: "45%",
            description: "Save Casting And Talent",
        },
    ],
};

export { config };
